/**
 * Created by chenqifeng on 2016/9/1.
 */
import {request} from '../http';
import domain from '../domain';
var SaleafterService = function () {
    if (domain.env === 'online') {
        this.domain = "//saleafter.51tiangou.com";
    } else {
        this.domain = "//saleafter." + domain.env + ".66buy.com.cn";
    }
};


SaleafterService.prototype.repealCancel = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/repealCancel", params);
};

//售后详情
SaleafterService.prototype.returnRequestDetail = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/returnRequest/detail", params);
};

//退货填写信息
SaleafterService.prototype.applyComplain = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/return/complain", params);
};

//退货填写信息
SaleafterService.prototype.addReturnInfo = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/addReturnInfo", params);
};

//修改退货物流信息
SaleafterService.prototype.updateReturnInfo = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/updTrackingNo", params);
};

//创建售后信息
SaleafterService.prototype.tgouOrdeReturn = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/return", params);
};

SaleafterService.prototype.returnCheckPoint = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/return/checkPoint", params);
};

SaleafterService.prototype.arbitralCheckPoint = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/return/checkPointByRRId", params);
};




//查询当前订单中可退金额
SaleafterService.prototype.queryAmt = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/returnRequest/queryAmt", params);
};

//取消售后
SaleafterService.prototype.cancelReturn = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/returnRequest/cancelReturn", params);
};


SaleafterService.prototype._serviceAjaxCom = function (url, params) {
    params.url = this.domain + url;
    request(params);
};

//退货进程
SaleafterService.prototype.returnRequestLogs = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/returnRequest/returnRequestLogs", params);
};

// 默认的上门取件收货人信息
SaleafterService.prototype.defaultReceiveInfo = function (params) {
    var that = this;
    that._serviceAjaxCom("/publics/xd/defaultReceiveInfo", params);
};

// 保存上门取件信息
SaleafterService.prototype.saveDoorPickUpInfo = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/xd/saveDoorPickUpInfo", params);
};

// 查看上门取货详情
SaleafterService.prototype.queryDoorPickUpDetail = function (params) {
    var that = this;
    that._serviceAjaxCom("/publics/xd/queryDoorPickUpDetail", params);
};

//获取退货原因
SaleafterService.prototype.getReturnReason = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/returnRequest/returnReason", params);
};

export default new SaleafterService();